export enum ITEM_ERROR_CODES {
  OUT_OF_STOCK = '005',
  NON_SERVICEABLE = '013',
  INSUFFICIENT_QTY_IN_STOCK = '006',
  MAX_SALEABLE_QTY = '007',
  INTERNATIONAL_NOT_AVAILABLE = '057',
}

export enum CART_PRESENTATION {
  'FREE_GIFT' = 'FREE_GIFT',
  'SAMPLE_GIFT' = 'SAMPLE_GIFT',
  'PRODUCTS' = 'PRODUCTS',
  'APPLY_COUPON' = 'APPLY_COUPON',
  'CROSS_SELLING' = 'CROSS_SELLING',
}

export enum ITEM_DISCOUNT_TYPE {
  MRP_RULES = 'mrp_rules',
  CATALOG_DISCOUNT = 'catalog_discount',
  YOU_PAY = 'you_pay',
  MRP = 'mrp',
}

export enum ITEM_DISCOUNT_PRIORITY {
  MRP_PRICE = 1,
  CATALOG_DISCOUNT = 2,
  MRP_DISCOUNT = 3,
  NON_MRP_DISCOUNT = 4,
  YOU_PAY_PRICE = 5,
}

export enum CART_ERROR_CODES {
  NOT_SERVICEABLE = '028',
}
